if (!customElements.get('lta-product-tabs')) {
	customElements.define(
		'lta-product-tabs',
		class LTAProductTabs extends HTMLElement {
			constructor() {
				super();

				this.tabs = this.querySelectorAll('[data-tab]');
				this.contents = this.querySelectorAll('[data-content]');

				console.log(this.tabs);
				console.log(this.contents);

				this.toggleTabs();
			}

			toggleTabs() {
				this.tabs.forEach((tab) => {
					tab.addEventListener('click', () => {
						const blockId = tab.dataset.tab;
						const matchContent = this.querySelector(`[data-content="${blockId}"]`);

						if (!matchContent) return;

						this.contents.forEach((collection) => collection.classList.add('hidden'));

						this.tabs.forEach((_tab) => {
							_tab == tab ? _tab.classList.add('active') : _tab.classList.remove('active');
						});

						matchContent.classList.remove('hidden');
					});
				});
			}
		}
	);
}

